import {
  FETCH_PEM_SUMMARY_COST_DATA_REQUEST,
  GET_PEM_SUMMARY_COST_DATA_SUCCESS,
  GET_PEM_SUMMARY_COST_DATA_FAILURE,
  FETCH_PEM_SUMMARY_TURNAROUND_DATA_REQUEST,
  GET_PEM_SUMMARY_TURNAROUND_DATA_SUCCESS,
  GET_PEM_SUMMARY_TURNAROUND_DATA_FAILURE,
  FETCH_PEM_SUMMARY_SERVICE_QUALITY_DATA_REQUEST,
  GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_SUCCESS,
  GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_FAILURE
} from "../../actions/actionTypes";

interface PEMSummaryState {
  costData: any[];
  turnaroundData: any[];
  serviceQualityData: any[];
  loading: boolean;
  error: any;
  costLoading: boolean;
  turnaroundLoading: boolean;
  serviceQualityLoading: boolean;
}

const initialState: PEMSummaryState = {
  costData: [],
  turnaroundData: [],
  serviceQualityData: [],
  loading: false,
  error: null,
  costLoading: false,
  turnaroundLoading: false,
  serviceQualityLoading: false
};

const pemSummaryReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PEMSummaryState => {
  switch (action.type) {
    // Cost Data
    case FETCH_PEM_SUMMARY_COST_DATA_REQUEST:
      return {
        ...state,
        costLoading: true,
        loading: true,
        error: null
      };
    case GET_PEM_SUMMARY_COST_DATA_SUCCESS:
      return {
        ...state,
        costData: action.payload?.Data || [],
        costLoading: false,
        loading: false,
        error: null
      };
    case GET_PEM_SUMMARY_COST_DATA_FAILURE:
      return {
        ...state,
        costLoading: false,
        loading: false,
        error: action.payload
      };

    // Turnaround Data
    case FETCH_PEM_SUMMARY_TURNAROUND_DATA_REQUEST:
      return {
        ...state,
        turnaroundLoading: true,
        loading: true,
        error: null
      };
    case GET_PEM_SUMMARY_TURNAROUND_DATA_SUCCESS:
      return {
        ...state,
        turnaroundData: action.payload?.Data || [],
        turnaroundLoading: false,
        loading: false,
        error: null
      };
    case GET_PEM_SUMMARY_TURNAROUND_DATA_FAILURE:
      return {
        ...state,
        turnaroundLoading: false,
        loading: false,
        error: action.payload
      };

    // Service Quality Data
    case FETCH_PEM_SUMMARY_SERVICE_QUALITY_DATA_REQUEST:
      return {
        ...state,
        serviceQualityLoading: true,
        loading: true,
        error: null
      };
    case GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_SUCCESS:
      return {
        ...state,
        serviceQualityData: action.payload?.Data || [],
        serviceQualityLoading: false,
        loading: false,
        error: null
      };
    case GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_FAILURE:
      return {
        ...state,
        serviceQualityLoading: false,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default pemSummaryReducer;